"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsLoginRequest = void 0;
var IsLoginRequest = /** @class */ (function () {
    function IsLoginRequest() {
    }
    return IsLoginRequest;
}());
exports.IsLoginRequest = IsLoginRequest;
//# sourceMappingURL=isLogin.request.js.map